import { z } from 'zod';
import {
  dateRangeSchema,
  paginationFiltersSchema,
  sortFiltersSchema,
} from 'utils/schemas';
import { transmissionActListVariants } from './transmission-acts.types';

const listVariantSchema = z.object({
  listVariant: z.enum(transmissionActListVariants).catch('reports'),
});

export const transmissionActsFiltersSchema = z
  .object({
    company: z.string().catch(''),
    date: dateRangeSchema,
  })
  .merge(listVariantSchema)
  .merge(paginationFiltersSchema)
  .merge(sortFiltersSchema);

export const transactionsFiltersSchema = z
  .object({
    company: z.string().catch(''),
    date: dateRangeSchema,
  })
  .merge(listVariantSchema);

export const depositsFiltersSchema = z
  .object({
    company: z.string().catch(''),
    date: dateRangeSchema,
  })
  .merge(listVariantSchema)
  .merge(sortFiltersSchema)
  .merge(paginationFiltersSchema);
